export default __webpack_public_path__ + "static/media/logoLine.9982de3a.webp";